import React from 'react'
// libs
import { InjectedFormProps, reduxForm } from 'redux-form'
// hooks
import { useSnackbar } from 'notistack'
// constants
import { Forms } from 'constants/forms'
// views
import { CopyIcon } from 'components/Modals/PropertyDetailsModal/components/Form/view'
import { Form, ButtonsWrapper } from './views'
// components
import { ReduxInput } from 'components/FormElements'
import { Button, BUTTON_LAYOUTS } from 'components/UI'
// view components
import CardFields from './components/CardFields'
import ImageFields from './components/ImageFields'
import SectionFields from './components/SectionFields'
import FunctionFields from './components/FunctionFields'
import StrategyActionsFields from './components/StrategyActionsFields'
// types
import { Image } from 'hooks/useImageUpload'
import { IOption } from 'components/FormElements/Select'
import { DashboardItemType } from 'types/graphql'

const getWidgetFields = (type: DashboardItemType) => {
  switch (type) {
    case DashboardItemType.Section: {
      return <SectionFields />
    }
    case DashboardItemType.Image: {
      return <ImageFields />
    }
    case DashboardItemType.Function: {
      return <FunctionFields />
    }
    case DashboardItemType.Card: {
      return <CardFields />
    }
    case DashboardItemType.StrategyActions: {
      return <StrategyActionsFields />
    }
  }
}

export type DashboardWidgetSettingsFormFields = {
  image: Image
  title: string
  width: number
  height: number
  padding: number
  filterId: IOption
  widgetId: string
  showTitle: boolean
  widgetType: string
  riskViewId: IOption
  dropShadow: boolean
  description: string
  functionType: IOption
  openInWindow: boolean
  transparency: number
  functionLink: string
  riskTemplateId: IOption
}

interface Props {
  widgetId?: string
  widgetType?: DashboardItemType
  onCancelClick: () => void
}

const WidgetDetailsForm: React.FC<InjectedFormProps<DashboardWidgetSettingsFormFields, Props> & Props> = ({
  widgetId,
  widgetType,
  handleSubmit,
  onCancelClick
}) => {
  const { enqueueSnackbar } = useSnackbar()

  const onCopyClick = () => {
    navigator.clipboard.writeText(widgetId)

    enqueueSnackbar('Copied!', {
      variant: 'info',
      autoHideDuration: 1000
    })
  }

  return (
    <Form onSubmit={handleSubmit}>
      <ReduxInput disabled name='widgetId' label='Widget ID' endAdornment={<CopyIcon onClick={onCopyClick} />} />
      <ReduxInput disabled name='widgetType' label='Widget Type' />
      {getWidgetFields(widgetType)}
      <ButtonsWrapper>
        <Button type='submit' layout={BUTTON_LAYOUTS.PURPLE}>
          Save
        </Button>
        <Button type='button' layout={BUTTON_LAYOUTS.PURPLE_INVERTED} onClick={onCancelClick}>
          Cancel
        </Button>
      </ButtonsWrapper>
    </Form>
  )
}

export default reduxForm<DashboardWidgetSettingsFormFields, Props>({
  form: Forms.DASHBOARD_WIDGET_SETTINGS_FORM,
  destroyOnUnmount: false,
  enableReinitialize: true
})(WidgetDetailsForm)
